import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLiveChat = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.5 8V13.2474C15.5 14.3389 14.402 15.5 13.3105 15.5H8.00006C3.85782 15.5 0.5 12.1421 0.5 8C0.5 3.85789 3.85782 0.5 8.00006 0.5C12.1422 0.5 15.5 3.85789 15.5 8ZM5.06 5.96C4.89431 5.96 4.76 6.0943 4.76 6.26C4.76 6.4257 4.89431 6.56 5.06 6.56H10.94C11.1057 6.56 11.24 6.4257 11.24 6.26C11.24 6.0943 11.1057 5.96 10.94 5.96H5.06ZM4.76 9.86C4.76 9.6943 4.89431 9.56 5.06 9.56H10.94C11.1057 9.56 11.24 9.6943 11.24 9.86C11.24 10.0257 11.1057 10.16 10.94 10.16H5.06C4.89431 10.16 4.76 10.0257 4.76 9.86ZM5.06 7.76C4.89431 7.76 4.76 7.8943 4.76 8.06C4.76 8.2257 4.89431 8.36 5.06 8.36H10.94C11.1057 8.36 11.24 8.2257 11.24 8.06C11.24 7.8943 11.1057 7.76 10.94 7.76H5.06Z",
		fill: "#1F4C5C"
	})]
});
const ForwardRef = forwardRef(SvgLiveChat);
export { ForwardRef as ReactComponent };
